import React, { Fragment } from 'react';
import { ClockIcon, ShoppingCartIcon } from 'lucide-react';
import { useMidnightCountdown } from '../hooks/useMidnightCountdown';
import { LegalLinks } from '../components/LegalLinks';
export function CheckoutBundlePage() {
  const {
    hours,
    minutes,
    seconds
  } = useMidnightCountdown();
  const pad = (n: number) => n < 10 ? `0${n}` : n;
  const handleCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = 'https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5';
  };
  const ImageFallback = ({
    text
  }: {
    text: string;
  }) => <div className="w-full aspect-square rounded-xl flex flex-col items-center justify-center text-center p-4 bg-gradient-to-br from-[#f0f9ff] to-[#cffafe] border border-[#67e8f9] font-['Anton'] text-[#0e7490] text-xl tracking-wide" data-id="element-104">
      {text.split('\\n').map((line, i) => <Fragment key={i} data-id="element-105">
          {line}
          <br data-id="element-106" />
        </Fragment>)}
    </div>;
  return <div className="min-h-screen bg-[url('https://cdn.magicpatterns.com/uploads/n7ea57jK586HPiiMHqCkL9/private_openrouter-generated-image-1781212646060.png')] bg-cover bg-center bg-fixed text-[#0f172a] font-['Inter'] selection:bg-[#36D9F4]/40" data-id="element-107">
      {/* FLOATING OFFER BAR */}
      <div className="sticky top-0 z-50 bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] border-b border-[#AA0E13]" data-id="element-108">
        <div className="max-w-[1180px] mx-auto px-4 h-11 flex items-center justify-between gap-3" data-id="element-109">
          <div className="flex items-center gap-2 min-w-0" data-id="element-110">
            <span className="hidden sm:inline font-semibold text-[12.5px] tracking-wide truncate" data-id="element-111">
              48 Hrs AI Cash Machine
            </span>
            <span className="hidden sm:inline text-white/50" data-id="element-112">·</span>
            <span className="font-['Anton'] text-[14px] leading-none" data-id="element-113">
              $297
            </span>
            <span className="text-[11px] text-white/70 line-through leading-none" data-id="element-114">
              $9,370
            </span>
          </div>
          <div className="flex items-center gap-3 shrink-0" data-id="element-115">
            <div className="flex items-center gap-1.5 text-[12.5px] tabular-nums" data-id="element-116">
              <ClockIcon className="w-3.5 h-3.5 text-white/80" data-id="element-117" />
              <span className="font-semibold tracking-tight" data-id="element-118">
                {pad(hours)}:{pad(minutes)}:{pad(seconds)}
              </span>
            </div>
            <a href="#" onClick={handleCheckout} className="inline-flex items-center rounded-full bg-white text-[#dc2626] text-[11px] font-bold uppercase tracking-wide px-3 py-1 hover:bg-white/90 transition-colors" data-id="element-119">
              Obtener acceso
            </a>
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <header className="bg-transparent border-b border-[#e2e8f0] pb-12" data-id="element-120">
        <div className="max-w-[1180px] mx-auto px-5" data-id="element-121">
          <div className="relative left-1/2 right-1/2 -mx-[50vw] w-screen mb-10 bg-gradient-to-b from-[#1e293b] to-[#0f172a] overflow-hidden" data-id="element-122">
            <div className="absolute inset-0 bg-[radial-gradient(80%_120%_at_50%_0%,rgba(54,217,244,0.18)_0%,transparent_60%)] pointer-events-none" data-id="element-123" />
            <div className="relative max-w-[920px] mx-auto px-5 py-12 sm:py-16" data-id="element-124">
              <h1 className="relative font-['Anton'] text-[clamp(28px,4.8vw,54px)] leading-[1.02] text-center uppercase tracking-[0.5px] text-[#ffffff]" data-id="element-125">
                Genera Tu Primer Ingreso con AI en las{' '}
                <span className="text-[#36D9F4]" data-id="element-126">Próximas 48 Horas</span> — Sin
                Experiencia y Sin Adivinar
              </h1>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-8 lg:gap-10 items-start" data-id="element-127">
            {/* LEFT COLUMN */}
            <div className="relative rounded-3xl border border-[#9ca3af] shadow-[0_10px_30px_rgba(0,0,0,0.12)] bg-white px-5 sm:px-7 pb-8 mt-20 sm:mt-28" data-id="element-128">
              <div className="-mt-28 sm:-mt-36 mb-4 flex justify-center" data-id="element-129">
                <img src="https://cdn.magicpatterns.com/uploads/gnQatCwJe9kqMyVCDBjSpQ/Whole_course.png" alt="48 Hrs AI Cash Machine — Bundle Completo" className="max-w-full lg:max-w-[620px] h-auto" onError={e => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }} data-id="element-130" />
                <div className="hidden w-full max-w-[480px]" data-id="element-131">
                  <ImageFallback text="WHOLE BUNDLE" data-id="element-132" />
                </div>
              </div>

              <div className="flex flex-col items-center mb-6" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/n1oFfYN2XRMVeV75JV8L7q/48_hours_block_final.svg" alt="Gabriel Beltran — 48 Hrs AI Cash Machine" className="w-full max-w-[320px] h-auto" data-id="element-134" />
              </div>

              <ul className="list-none space-y-0" data-id="element-135">
                {[{
                title: '48 Hrs AI Cash Machine',
                accent: 'Cash Machine',
                sub: 'El sistema central de 7 pasos para generar tu primer ingreso con AI.'
              }, {
                title: 'AI Web Closer Academy',
                accent: 'Web Closer',
                sub: 'Incluye el software AI Website Sales Accelerator y los scripts de cierre.'
              }, {
                title: 'Facebook Ads Expert',
                accent: 'Facebook',
                sub: 'Mastery Course & Systems: targeting, creación, optimización y escala.'
              }, {
                title: 'Build AI Websites',
                accent: 'AI Websites',
                sub: 'AI Website Builder System + plantillas de sitios incluidas.'
              }, {
                title: 'The Ultimate AI Creator Bundle',
                accent: 'AI Creator',
                sub: 'Produce imágenes y videos con AI de nivel profesional.'
              }, {
                title: 'Custom AI Brains',
                accent: 'AI Brains',
                sub: 'Autopilot AI System: tu asistente AI preprogramado para cada paso.'
              }, {
                bonus: true,
                title: 'BONO: Llamadas en vivo todos los miércoles',
                accent: 'BONO:',
                sub: '12 meses de acompañamiento en directo, cada semana.'
              }, {
                bonus: true,
                title: 'BONO: Website Templates Con CRM Customized',
                accent: 'BONO:',
                sub: 'Plantillas de sitios web con CRM personalizado.'
              }, {
                bonus: true,
                title: 'BONO: Acceso a la comunidad privada de 48 Hrs AI Cash Machine en SKOOL',
                accent: 'BONO:',
                sub: 'Únete a la comunidad privada en la aplicación SKOOL.'
              }].map((item, i) => {
                const [before, after] = item.accent ? (() => {
                  const idx = item.title.indexOf(item.accent);
                  return idx === -1 ? [item.title, ''] : [item.title.slice(0, idx), item.title.slice(idx + item.accent.length)];
                })() : [item.title, ''];
                return <li key={i} className="relative pl-9 py-3 border-b border-[#e2e8f0]" data-id="element-136">
                      <span className="absolute left-0 top-3.5 w-5 h-5 rounded-full bg-[#0350AE] flex items-center justify-center" data-id="element-137">
                        <span className="w-3.5 h-3.5 bg-white" style={{
                      WebkitMask: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' d='M5 12h14m-6-6 6 6-6 6'/></svg>\") center/contain no-repeat",
                      mask: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' d='M5 12h14m-6-6 6 6-6 6'/></svg>\") center/contain no-repeat"
                    }} data-id="element-138" />
                      </span>
                      <p className="font-extrabold text-[16px] sm:text-[17px] leading-tight text-[#0f172a]" data-id="element-139">
                        {item.accent ? <>
                            {before}
                            <span className="text-[#dc2626]" data-id="element-140">
                              {item.accent}
                            </span>
                            {after}
                          </> : item.title}
                      </p>
                      <p className="mt-1 text-[14px] leading-snug text-[#64748b]" data-id="element-141">
                        {item.sub}
                      </p>
                    </li>;
              })}
              </ul>

              <div className="text-center mt-7 mb-2" data-id="element-142">
                <div className="font-['Anton'] tracking-[1px] text-[26px] sm:text-[32px] text-[#0f172a] mb-4" data-id="element-143">
                  Precio exclusivo de hoy…
                </div>
                <div className="flex items-center justify-center gap-4 sm:gap-6 flex-wrap" data-id="element-144">
                  <span className="font-['Anton'] text-[56px] sm:text-[80px] leading-none text-[#0f172a] line-through decoration-[#dc2626] decoration-[5px]" data-id="element-145">
                    $9,370
                  </span>
                  <span className="font-['Anton'] text-[52px] sm:text-[76px] leading-none bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] px-6 sm:px-8 pt-2 pb-1 rounded-xl" data-id="element-146">
                    $297
                  </span>
                </div>
                <div className="font-['Anton'] tracking-[0.5px] text-[18px] sm:text-[22px] text-[#475569] mt-5" data-id="element-147">
                  O 4 pagos de $126.25
                </div>
              </div>

              <div className="flex items-center gap-5 justify-center mt-8 max-w-[460px] mx-auto" data-id="element-148">
                <img src="https://cdn.magicpatterns.com/uploads/we8juYLVhboSuTkVksAsiQ/money_back.png" alt="Garantía de devolución 100% — Reembolso garantizado" className="shrink-0 w-[110px] sm:w-[124px] h-auto" data-id="element-149" />
                <p className="text-[15px] sm:text-[16px] text-[#0f172a] text-left leading-relaxed" data-id="element-150">
                  Si no quedas completamente satisfecho, te ofrecemos una{' '}
                  <b className="text-[#dc2626] font-bold" data-id="element-151">
                    garantía de devolución total
                  </b>
                  . <span className="underline" data-id="element-152">Sin preguntas.</span>
                </p>
              </div>
            </div>

            {/* RIGHT COLUMN: CTA */}
            <div className="lg:sticky lg:top-8" data-id="element-153">
              <div className="bg-[#ffffff] border border-[#9ca3af] shadow-[0_10px_30px_rgba(0,0,0,0.12)] rounded-xl p-6 sm:p-8 text-center" data-id="element-154">
                <h3 className="text-[20px] font-[800] mb-1 text-[#0f172a]" data-id="element-155">
                  Asegura tu acceso hoy
                </h3>
                <p className="text-[13px] text-[#64748b] mb-5" data-id="element-156">
                  El precio promocional por tiempo limitado expira en…
                </p>

                <div className="flex justify-center gap-2.5 mb-6" data-id="element-157">
                  <div className="bg-[#fef2f2] border border-[#fca5a5] rounded-lg min-w-[64px] py-2 px-1.5 text-center" data-id="element-158">
                    <div className="font-['Anton'] text-[26px] text-[#dc2626] leading-none" data-id="element-159">
                      {pad(hours)}
                    </div>
                    <div className="text-[9px] tracking-[1.5px] text-[#64748b] uppercase mt-1" data-id="element-160">
                      Horas
                    </div>
                  </div>
                  <div className="bg-[#fef2f2] border border-[#fca5a5] rounded-lg min-w-[64px] py-2 px-1.5 text-center" data-id="element-161">
                    <div className="font-['Anton'] text-[26px] text-[#dc2626] leading-none" data-id="element-162">
                      {pad(minutes)}
                    </div>
                    <div className="text-[9px] tracking-[1.5px] text-[#64748b] uppercase mt-1" data-id="element-163">
                      Min
                    </div>
                  </div>
                  <div className="bg-[#fef2f2] border border-[#fca5a5] rounded-lg min-w-[64px] py-2 px-1.5 text-center" data-id="element-164">
                    <div className="font-['Anton'] text-[26px] text-[#dc2626] leading-none" data-id="element-165">
                      {pad(seconds)}
                    </div>
                    <div className="text-[9px] tracking-[1.5px] text-[#64748b] uppercase mt-1" data-id="element-166">
                      Seg
                    </div>
                  </div>
                </div>

                {/* Price recap */}
                <div className="flex items-center justify-center gap-3 mb-6 flex-wrap" data-id="element-167">
                  <span className="font-['Anton'] text-[28px] text-[#64748b] line-through decoration-[#94a3b8]" data-id="element-168">
                    $9,370
                  </span>
                  <span className="font-['Anton'] text-[40px] bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] px-5 pt-1 rounded-md" data-id="element-169">
                    $297
                  </span>
                </div>

                <a href="#" onClick={handleCheckout} className="relative overflow-hidden flex items-center justify-center gap-2.5 w-full bg-[#3FAC00] hover:bg-[#43B800] text-[#ffffff] font-extrabold text-[20px] tracking-tight p-4 rounded-lg transition-all duration-150 hover:-translate-y-0.5 active:translate-y-[2px] shadow-[0_4px_0_#2C7A00,0_1px_3px_rgba(0,0,0,0.07)] active:shadow-[0_2px_0_#2C7A00,0_1px_2px_rgba(0,0,0,0.07)]" data-id="element-170">
                  <span className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-lg bg-gradient-to-b from-white/35 to-transparent" data-id="element-171" />
                  <ShoppingCartIcon className="relative w-5 h-5 drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" data-id="element-172" />
                  <span className="relative [text-shadow:0_1px_2px_rgba(0,0,0,0.35)]" data-id="element-173">
                    Obtén Acceso Ahora
                  </span>
                </a>

                <img src="https://cdn.magicpatterns.com/uploads/76cD3Rx79bU816uiFSdXqq/6814f798ca2000ae092e5f68.png" alt="Pago seguro con Stripe — Visa, Mastercard, American Express, Discover, Payoneer, Apple Pay, PayPal" className="w-full max-w-[220px] h-auto mx-auto mt-4" data-id="element-174" />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* QUOTE SECTION */}
      <section className="bg-gradient-to-b from-[#1e293b] to-[#0f172a] text-[#ffffff] text-center py-6 px-5" data-id="element-175">
        <p className="max-w-[880px] mx-auto text-[clamp(16px,2.2vw,22px)] font-light leading-[1.35] text-[#ffffff]" data-id="element-176">
          "No necesitas más motivación. Necesitas un sistema que te dé
          resultados esta semana — y que dependa de tu ejecución, no de tu
          suerte." <b className="font-bold text-[#ffffff]" data-id="element-177">— Gabriel Beltrán</b>
        </p>
      </section>

      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-14" data-id="element-178">
        <div className="max-w-[1180px] mx-auto px-5" data-id="element-179">
          <span className="block text-center bg-gradient-to-r from-[#FD0200] to-[#AA0E13] text-[#ffffff] font-['Poppins'] font-bold tracking-normal text-[clamp(14px,2.3vw,21px)] leading-tight max-w-[660px] mx-auto mb-2 py-3 px-7 rounded-[10px]" data-id="element-180">
            Esto es todo lo que recibes cuando aseguras tu
          </span>
          <div className="flex justify-center mt-3.5 mb-10" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/n1oFfYN2XRMVeV75JV8L7q/48_hours_block_final.svg" alt="Gabriel Beltran — 48 Hrs AI Cash Machine" className="w-full max-w-[550px] h-auto" data-id="element-182" />
          </div>

          <div className="space-y-5" data-id="element-183">
            {[{
            title: '48 Hrs AI Cash Machine',
            tag: '(Sistema Central)',
            benefit: 'Tu primer ingreso con AI en un plan de 48 horas',
            img: 'https://cdn.magicpatterns.com/uploads/et7g9SXQ6R2S4NhvuLF2px/48_HRS.png',
            fallback: '48 HOURS\\nAI CASH MACHINE',
            bullets: ['El proceso completo de 7 pasos: Targets, Marketing, Leads, Ventas y Escala — ya armado.', 'Plantillas y prompts listos para copiar y ejecutar el mismo día.', 'Pasos concretos y medibles, sin relleno y sin teoría que no aplicas.']
          }, {
            title: 'AI Web Closer Academy',
            tag: '',
            benefit: 'Cierra clientes de negocios locales con AI',
            img: 'https://cdn.magicpatterns.com/uploads/vAtF5NAms3ZTbyUfkAw9K7/Ai_Web_Closer-2.png',
            fallback: 'AI WEB CLOSER\\nACADEMY',
            bullets: ['AI Prospecting Playbook + 90 Day AI Closing Blueprint paso a paso.', 'Acceso al software AI Website Sales Accelerator para gestionar tus cierres.', 'Local Business AI Scripts + AI Closer Elite Mastermind con la comunidad.']
          }, {
            title: 'Facebook Ads Expert',
            tag: '(Mastery Course & Systems)',
            benefit: 'Convierte la atención en clientes que pagan',
            img: 'https://cdn.magicpatterns.com/uploads/h2AGtNXx3iPYeMyn42Getp/Facebook_Ads_Expert-2.png',
            fallback: 'FACEBOOK\\nADS EXPERT',
            bullets: ['Targeting, creación de anuncios y lanzamiento — explicado paso a paso.', 'Estructura de campaña y de presupuesto que ya funciona en el mercado.', 'Optimización y escala basadas en datos reales, no en suposiciones.']
          }, {
            title: 'Build AI Websites',
            tag: '(AI Website Builder System)',
            benefit: 'Crea sitios web con AI en minutos, no en semanas',
            img: 'https://cdn.magicpatterns.com/uploads/uSEdrUzRP8WQMiL2k1kAgn/How_To_Websites.png',
            fallback: 'BUILD AI\\nWEBSITES',
            bullets: ['Sistema completo para construir sitios web profesionales usando AI.', 'Plantillas de sitios incluidas y listas para personalizar.', 'Un servicio que puedes vender a negocios locales desde el día uno.']
          }, {
            title: 'The Ultimate AI Creator Bundle',
            tag: '(Imágenes y Videos)',
            benefit: 'Produce imágenes y videos con AI de nivel profesional',
            img: 'https://cdn.magicpatterns.com/uploads/xdUczHdFzD4ia5JY8o9dbh/Ai_Image___video.png',
            fallback: 'THE ULTIMATE\\nAI CREATOR BUNDLE',
            bullets: ['AI Image Generation Mastery + Isolated AI Video Production.', "Prompt Engineering Guide y AI Creator's Workbook para producir rápido.", 'Automation & Workflow Secrets para crear contenido en serie.']
          }, {
            title: 'Custom AI Brains',
            tag: '(Autopilot AI System)',
            benefit: 'Tu asistente AI preprogramado para cada paso',
            img: 'https://cdn.magicpatterns.com/uploads/jiLDx9YCn8BDUyNwcdufrn/Custom_Lloyds-2.png',
            fallback: 'CUSTOM AI BRAINS\\nAUTOPILOT SYSTEM',
            bullets: ['AI a la medida que maneja automatización, datos y ejecución por ti.', 'Reportes y optimización sin que tengas que estar encima del proceso.', 'Diseñado para que el sistema trabaje mientras tú te enfocas en vender.']
          }].map((card, i) => <article key={i} className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-7 items-center bg-[#ffffff] border border-[#9ca3af] shadow-[0_10px_30px_rgba(0,0,0,0.12)] rounded-xl p-6" data-id="element-184">
                <div className="flex items-center justify-center" data-id="element-185">
                  <img src={card.img.startsWith('http') ? card.img : `/${card.img}`} alt={card.title} className="w-full max-h-[340px] sm:max-h-[300px] md:max-h-[230px] object-contain" onError={e => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }} data-id="element-186" />
                  <div className="hidden w-full max-w-[300px]" data-id="element-187">
                    <ImageFallback text={card.fallback} data-id="element-188" />
                  </div>
                </div>
                <div className="text-center md:text-left" data-id="element-189">
                  <h2 className="text-[23px] font-[800] mb-2.5 text-[#0f172a]" data-id="element-190">
                    {card.title}{' '}
                    {card.tag && <span className="text-[#dc2626]" data-id="element-191">{card.tag}</span>}
                  </h2>
                  <span className="block w-full text-center md:text-left bg-gradient-to-r from-[#FD0200] to-[#AA0E13] text-[#ffffff] font-['Poppins'] font-bold text-[15px] leading-tight px-7 py-3 rounded-full mb-3.5 shadow-sm" data-id="element-192">
                    {card.benefit}
                  </span>
                  <ul className="space-y-1.5 text-left" data-id="element-193">
                    {card.bullets.map((bullet, j) => <li key={j} className="relative pl-9 py-1 text-[14.5px] text-[#334155] leading-relaxed" data-id="element-194">
                        <span className="absolute left-0 top-1 w-5 h-5 rounded-full bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] text-[12px] font-[800] flex items-center justify-center leading-none" data-id="element-195">
                          →
                        </span>
                        {bullet}
                      </li>)}
                  </ul>
                </div>
              </article>)}

            {/* BONUS CARDS */}
            {[{
            num: 1,
            title: 'Llamadas en Vivo Todos los Miércoles',
            benefit: 'Acompañamiento directo durante 12 meses',
            img: 'https://cdn.magicpatterns.com/uploads/ofaWhTtk4f8R4qHM8Vt98e/Weekly_Mastermind_Calls.png',
            fallback: 'BONO\\nLLAMADAS\\nEN VIVO',
            bullets: ['Sesión semanal en vivo para resolver tus dudas reales de ejecución.', 'Revisión de tus anuncios, tu oferta y tus cierres en tiempo real.', 'Acceso a la comunidad de quienes ya están ejecutando el sistema.']
          }, {
            num: 2,
            title: 'Website Templates Con CRM Customized',
            benefit: 'Plantillas de sitios web con CRM personalizado',
            img: 'https://cdn.magicpatterns.com/uploads/6d9LM81uEV7CZ3u3aGjF2e/Website_templates.png',
            fallback: 'BONO\\nWEBSITE TEMPLATES\\n+ CRM',
            bullets: ['Plantillas de sitios web profesionales listas para personalizar y publicar.', 'CRM personalizado integrado para capturar, organizar y dar seguimiento a tus leads.', 'Todo conectado en un solo lugar para que empieces a operar esta misma semana.']
          }, {
            num: 3,
            title: 'Comunidad Privada en SKOOL',
            benefit: 'Acceso a la comunidad privada de 48 Hrs AI Cash Machine',
            img: 'https://cdn.magicpatterns.com/uploads/pKwPbw4NUGCr5KcGEsv6kD/private_openrouter-generated-image-1781213810744.png',
            fallback: 'BONO\\nCOMUNIDAD\\nPRIVADA SKOOL',
            bullets: ['Acceso a la comunidad privada de 48 Hrs AI Cash Machine en la aplicación SKOOL.', 'Conecta con otros miembros que están ejecutando el mismo sistema.', 'Comparte avances, resuelve dudas y mantente acompañado en cada paso.']
          }].map((bonus, i) => <article key={`bonus-${i}`} className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-7 items-center bg-white border border-[#9ca3af] shadow-[0_10px_30px_rgba(0,0,0,0.12)] rounded-xl p-6" data-id="element-196">
                <div className="flex items-center justify-center" data-id="element-197">
                  {bonus.img ? <img src={bonus.img} alt={bonus.title} className="w-full max-h-[340px] sm:max-h-[300px] md:max-h-[230px] object-contain" onError={e => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove('hidden');
              }} data-id="element-198" /> : null}
                  <div className={`w-full max-w-[300px] ${bonus.img ? 'hidden' : ''}`} data-id="element-199">
                    <ImageFallback text={bonus.fallback} data-id="element-200" />
                  </div>
                </div>
                <div className="text-center md:text-left" data-id="element-201">
                  <h2 className="text-[23px] font-[800] mb-2.5 text-[#0f172a] leading-tight" data-id="element-202">
                    <span className="text-[#dc2626]" data-id="element-203">BONO #{bonus.num}:</span>{' '}
                    {bonus.title}
                  </h2>
                  <span className="block w-full text-center md:text-left bg-gradient-to-r from-[#FD0200] to-[#AA0E13] text-[#ffffff] font-['Poppins'] font-bold text-[15px] leading-tight px-7 py-3 rounded-full mb-3.5 shadow-sm" data-id="element-204">
                    {bonus.benefit}
                  </span>
                  <ul className="space-y-1.5 text-left" data-id="element-205">
                    {bonus.bullets.map((bullet, j) => <li key={j} className="relative pl-9 py-1 text-[14.5px] text-[#334155] leading-relaxed" data-id="element-206">
                        <span className="absolute left-0 top-1 w-5 h-5 rounded-full bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] text-[12px] font-[800] flex items-center justify-center leading-none" data-id="element-207">
                          →
                        </span>
                        {bullet}
                      </li>)}
                  </ul>
                </div>
              </article>)}
          </div>

          <hr className="border-0 border-t border-[#64748b] mt-12" data-id="element-208" />
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="py-14 text-center border-t border-[#e2e8f0] bg-transparent" data-id="element-209">
        <div className="max-w-[1180px] mx-auto px-5" data-id="element-210">
          <div className="flex justify-center mb-0 -mt-[52px]" data-id="element-211">
            <img src="https://cdn.magicpatterns.com/uploads/n1oFfYN2XRMVeV75JV8L7q/48_hours_block_final.svg" alt="Gabriel Beltran — 48 Hrs AI Cash Machine" className="w-full max-w-[499px] h-auto" data-id="element-212" />
          </div>

          <div className="mb-0 sm:-mb-8 flex justify-center" data-id="element-213">
            <img src="https://cdn.magicpatterns.com/uploads/gnQatCwJe9kqMyVCDBjSpQ/Whole_course.png" alt="48 Hrs AI Cash Machine — Bundle Completo" className="max-w-full sm:max-w-[1008px] h-auto" onError={e => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }} data-id="element-214" />
            <div className="hidden w-full max-w-[560px]" data-id="element-215">
              <ImageFallback text="WHOLE BUNDLE" data-id="element-216" />
            </div>
          </div>

          <div className="text-center mt-0 mb-2" data-id="element-217">
            <div className="font-['Poppins'] font-normal tracking-normal text-[22px] sm:text-[28px] text-[#0f172a] mb-4" data-id="element-218">
              Precio exclusivo de hoy…
            </div>
            <div className="flex items-center justify-center gap-4 sm:gap-6 flex-wrap" data-id="element-219">
              <span className="font-['Anton'] text-[56px] sm:text-[80px] leading-none text-[#0f172a] line-through decoration-[#dc2626] decoration-[5px]" data-id="element-220">
                $9,370
              </span>
              <span className="font-['Anton'] text-[52px] sm:text-[76px] leading-none bg-gradient-to-b from-[#FD0200] to-[#AA0E13] text-[#ffffff] px-6 sm:px-8 pt-2 pb-1 rounded-xl" data-id="element-221">
                $297
              </span>
            </div>
          </div>

          <a href="#" onClick={handleCheckout} className="relative overflow-hidden flex items-center justify-center gap-3 w-full max-w-[620px] mx-auto mt-5 bg-[#3FAC00] hover:bg-[#43B800] text-[#ffffff] font-extrabold text-[18px] sm:text-[24px] tracking-tight p-4 rounded-full transition-all duration-150 hover:-translate-y-0.5 active:translate-y-[2px] shadow-[0_4px_0_#2C7A00,0_1px_3px_rgba(0,0,0,0.07)] active:shadow-[0_2px_0_#2C7A00,0_1px_2px_rgba(0,0,0,0.07)]" data-id="element-222">
            <span className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full bg-gradient-to-b from-white/35 to-transparent" data-id="element-223" />
            <ShoppingCartIcon className="relative w-6 h-6 shrink-0 drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" data-id="element-224" />
            <span className="relative [text-shadow:0_1px_2px_rgba(0,0,0,0.35)]" data-id="element-225">
              ¡Quiero el 48 Hrs AI Cash Machine!
            </span>
          </a>

          <div className="flex items-center gap-5 justify-center mt-8 max-w-[560px] mx-auto bg-white border-2 border-dotted border-[#D4AF37] rounded-2xl p-5 sm:p-7" data-id="element-226">
            <img src="https://cdn.magicpatterns.com/uploads/we8juYLVhboSuTkVksAsiQ/money_back.png" alt="Garantía de devolución 100% — Reembolso garantizado" className="shrink-0 w-[110px] sm:w-[124px] h-auto" data-id="element-227" />
            <p className="text-[15px] sm:text-[16px] text-[#0f172a] text-left leading-relaxed" data-id="element-228">
              Si no quedas completamente satisfecho, te ofrecemos una{' '}
              <b className="text-[#dc2626] font-bold" data-id="element-229">
                garantía de devolución total
              </b>
              . <span className="underline" data-id="element-230">Sin preguntas.</span>
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0f172a] border-t border-[#1e293b] py-8 text-[12px] text-[#94a3b8]" data-id="element-231">
        <div className="max-w-[1180px] mx-auto px-5" data-id="element-232">
          <p className="max-w-[920px] mx-auto text-center leading-[1.6] text-[11px] text-[#94a3b8]" data-id="element-233">
            En True Marketer LLC creemos que el éxito es resultado del trabajo,
            la educación y la persistencia. Los ejemplos mostrados no deben
            considerarse típicos y no hay garantía de resultados. La información
            de este sitio es educativa por naturaleza y no constituye asesoría
            legal ni financiera. Al usar este sitio aceptas la responsabilidad
            total de tus propios resultados; nuestro equipo está aquí para
            apoyarte, pero siempre debes hacer tu propia investigación antes de
            tomar cualquier decisión de inversión o de negocio. Este sitio no
            está afiliado a Meta, Facebook ni a ninguna plataforma de terceros.
            <br data-id="element-234" />
            <br data-id="element-235" />
            <b className="text-[#e2e8f0]" data-id="element-236">True Marketer LLC</b>
            <br data-id="element-237" />© {new Date().getFullYear()} True Marketer LLC. Todos los
            derechos reservados.
          </p>

          <LegalLinks containerClassName="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1.5 mt-5 text-[#cbd5e1]" linkClassName="hover:text-[#36D9F4] mx-1.5 underline-offset-2 hover:underline" data-id="element-238" />
        </div>
      </footer>
    </div>;
}